import { User } from "firebase/auth";
import { apiFetch } from "./client";

export interface Player {
  id: string;
  name: string;
  club: string;
  position: string | null;
  nationality: string | null;
  squadNumber: number | null;
  dateOfBirth: string | null;
  pictureUrl: string | null;
}

export interface PlayersPage {
  players: Player[];
  total: number;
  page: number;
  pageSize: number;
}

export function fetchPlayers(
  user: User,
  params: {
    competitionId: string;
    page?: number;
    pageSize?: number;
    search?: string;
    club?: string;
    position?: string;
    sort?: "goals";
    excludePlayerIds?: string[];
  },
): Promise<PlayersPage> {
  const q = new URLSearchParams();
  q.set("competitionId", params.competitionId);
  if (params.page) q.set("page", String(params.page));
  if (params.pageSize) q.set("pageSize", String(params.pageSize));
  if (params.search) q.set("search", params.search);
  if (params.club) q.set("club", params.club);
  if (params.position) q.set("position", params.position);
  if (params.sort) q.set("sort", params.sort);
  if (params.excludePlayerIds && params.excludePlayerIds.length > 0) q.set("excludePlayerIds", params.excludePlayerIds.join(","));
  return apiFetch(user, `/players?${q}`);
}

export function fetchClubs(user: User, competitionId: string): Promise<string[]> {
  return apiFetch(user, `/players/clubs?competitionId=${encodeURIComponent(competitionId)}`);
}
